export default __webpack_public_path__ + "static/media/Scroll saw PROXXON.6d6bcbde.png";